import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { TextField } from "@/components/FormKit";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-blue noise-overlay px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl sm:p-10">
        <div className="flex justify-center"><Logo /></div>
        <h1 className="mt-6 text-center font-heading text-2xl font-bold text-slate-900">Admin Dashboard</h1>
        <p className="mt-1 text-center text-sm text-slate-500">Sign in to manage leads and content</p>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-5">
          <TextField label="Email" required testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <TextField label="Password" required testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="h-13 w-full rounded-full bg-brand-purple text-base font-semibold text-white hover:bg-brand-purple2">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
